import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicElementsIconComponent } from './components/icon/icon.component';
import { DontTreeShake } from '@epicuro-next/elements/core';

@NgModule({
  imports: [CommonModule],
  declarations: [DynamicElementsIconComponent],
})
export class DynamicElementsIconModule {}

DontTreeShake(DynamicElementsIconComponent);
